import { colorsPalettes } from "@similarweb/styles";

import type { IStepScreenProps } from "app/components/ChangeSolutionModal/types";
import I18n, { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { AssetsService } from "app/services/AssetsService";

import { StyledScreenWrapper, StyledScreenTitle, StyledScreenDescription, StyledIllustration } from "../../styles";

const { carbon } = colorsPalettes;

export const DefaultSuccessScreen = ({ config }: IStepScreenProps) => {
    const translate = useTranslation();
    return (
        <StyledScreenWrapper>
            <StyledScreenTitle
                fontVariant="h3"
                color={carbon[500]}
            >
                <I18n dangerouslySetInnerHTML>{translate(config.title)}</I18n>
            </StyledScreenTitle>
            <StyledScreenDescription
                fontVariant="h6"
                color={carbon[400]}
            >
                <I18n dangerouslySetInnerHTML>{translate(config.subTitle)}</I18n>
            </StyledScreenDescription>
            <StyledIllustration>
                <img
                    src={AssetsService.assetUrl("/images/swicons/illustration-upgrade.svg")}
                    alt=""
                />
            </StyledIllustration>
        </StyledScreenWrapper>
    );
};
